import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Grid,
  Paper,
  Input,
  Switch,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";
import {
  Home,
  Work,
  School,
  Business,
  FitnessCenter,
  Favorite,
  Code,
  Receipt,
  Print,
  Description,
} from "@material-ui/icons";
import axios from "axios";
import { useFormik } from "formik";
import * as Yup from "yup";
import { uri } from "../../../../help/Api";
import { useTranslation } from "react-i18next";

const icons = [
  { name: "Print", component: Print },
  { name: "Receipt", component: Receipt },
  //   { name: "School", component: School },
  { name: "Discription", component: Description },
  { name: "FitnessCenter", component: FitnessCenter },
  { name: "Favorite", component: Favorite },
  { name: "Code", component: Code },
];

// const AddTemplate = ({ isEditMode, existingTemplate, onCancel }) => {
//   const [templateName, setTemplateName] = useState("");
//   const [templateFile, setTemplateFile] = useState(null);
//   const [selectedIcon, setSelectedIcon] = useState("");

//   useEffect(() => {
//     if (isEditMode && existingTemplate) {
//       setTemplateName(existingTemplate.name);
//       setTemplateFile(existingTemplate.file);
//       setSelectedIcon(existingTemplate.icon);
//     }
//   }, [isEditMode, existingTemplate]);

//   const handleTemplateNameChange = (e) => setTemplateName(e.target.value);
//   const handleTemplateFileChange = (e) => setTemplateFile(e.target.files[0]);
//   const handleIconChange = (e) => setSelectedIcon(e.target.value);

//   const handleTestTemplate = () => {
//     // Logic to test the template
//     console.log("Testing template:", {
//       templateName,
//       templateFile,
//       selectedIcon,
//     });
//   };

//   const handleSaveTemplate = () => {
//     // Logic to save the template, send the data to the API
//     const formData = new FormData();
//     formData.append("templateName", templateName);
//     formData.append("templateFile", templateFile);
//     formData.append("templateIcon", selectedIcon);

//     const apiEndpoint = isEditMode
//       ? `/api/edit-template/${existingTemplate.id}`
//       : "/api/save-template";

//     fetch(apiEndpoint, {
//       method: "POST",
//       body: formData,
//     })
//       .then((response) => response.json())
//       .then((data) => {
//         console.log("Template saved:", data);
//         onCancel(); // Return to table view after saving
//       })
//       .catch((error) => {
//         console.error("Error saving template:", error);
//       });
//   };

//   const SelectedIconComponent =
//     icons.find((icon) => icon.name === selectedIcon)?.component || null;

//   return (
//     <Paper elevation={3} style={{ padding: "20px", marginTop: "20px" }}>
//       <Typography variant="h5" component="h3">
//         {isEditMode ? "Edit Template" : "Add New Template"}
//       </Typography>
//       <Grid container spacing={3} style={{ marginTop: "20px" }}>
//         <Grid item xs={12}>
//           <TextField
//             label="Template Name"
//             fullWidth
//             value={templateName}
//             onChange={handleTemplateNameChange}
//           />
//         </Grid>
//         <Grid item xs={12}>
//           <Input
//             type="file"
//             onChange={handleTemplateFileChange}
//             inputProps={{ accept: ".docx,.pdf" }}
//           />
//         </Grid>
//         <Grid item xs={12}>
//           <FormControl fullWidth>
//             <InputLabel id="icon-select-label">Choose Icon</InputLabel>
//             <Select
//               labelId="icon-select-label"
//               value={selectedIcon}
//               onChange={handleIconChange}
//               label="Choose Icon"
//             >
//               {icons.map((icon) => (
//                 <MenuItem key={icon.name} value={icon.name}>
//                   {icon.name}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//           {SelectedIconComponent && (
//             <div style={{ marginTop: "20px", textAlign: "center" }}>
//               <SelectedIconComponent style={{ fontSize: 40 }} />
//             </div>
//           )}
//         </Grid>
//         <Grid item xs={6}>
//           <Button
//             variant="contained"
//             color="secondary"
//             fullWidth
//             onClick={handleTestTemplate}
//           >
//             Test Template
//           </Button>
//         </Grid>
//         <Grid item xs={6}>
//           <Button
//             variant="contained"
//             color="primary"
//             fullWidth
//             onClick={handleSaveTemplate}
//           >
//             {isEditMode ? "Update Template" : "Save Template"}
//           </Button>
//         </Grid>
//         <Grid item xs={12}>
//           <Button variant="outlined" fullWidth onClick={onCancel}>
//             Cancel
//           </Button>
//         </Grid>
//       </Grid>
//     </Paper>
//   );
// };

// export default AddTemplate;

// import React, { useState } from "react";
// import axios from "axios";
// import {
//   TextField,
//   Button,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Switch,
//   Typography,
//   Grid,
//   Paper,
// } from "@mui/material";

// const AddTemplate = () => {
//   const [templateName, setTemplateName] = useState("");
//   const [templateFile, setTemplateFile] = useState(null);
//   const [selectedIcon, setSelectedIcon] = useState("");
//   const [templateState, setTemplateState] = useState(false);

//   const handleTemplateNameChange = (e) => setTemplateName(e.target.value);
//   const handleTemplateFileChange = (e) => setTemplateFile(e.target.files[0]);
//   const handleIconChange = (e) => setSelectedIcon(e.target.value);
//   const handleStateChange = (e) => setTemplateState(e.target.checked);
//   const SelectedIconComponent =
//     icons.find((icon) => icon.name === selectedIcon)?.component || null;

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const formData = new FormData();
//     formData.append("FileName", templateFile);
//     formData.append("Name", templateName);
//     formData.append("IconName", selectedIcon);
//     formData.append("State", templateState);

//     try {
//       const response = await axios.post(
//         "http://localhost:8189/api/templates",
//         formData,
//         {
//           headers: {
//             "Content-Type": "multipart/form-data",
//           },
//         }
//       );
//       console.log("Template added successfully", response.data);
//       // Reset form fields
//       setTemplateName("");
//       setTemplateFile(null);
//       setSelectedIcon("");
//       setTemplateState(false);
//     } catch (error) {
//       console.error("Error adding template", error);
//     }
//   };

//   return (
//     <Paper elevation={3} style={{ padding: "20px", marginTop: "20px" }}>
//       <Typography variant="h5" component="h3">
//         Add New Template
//       </Typography>
//       <form onSubmit={handleSubmit}>
//         <Grid container spacing={3} style={{ marginTop: "20px" }}>
//           <Grid item xs={12}>
//             <TextField
//               label="Template Name"
//               fullWidth
//               value={templateName}
//               onChange={handleTemplateNameChange}
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <input
//               type="file"
//               onChange={handleTemplateFileChange}
//               accept=".docx,.pdf"
//               style={{ display: "none" }}
//               id="templateFile"
//             />
//             <label htmlFor="templateFile">
//               <Button variant="contained" component="span">
//                 Upload Template File
//               </Button>
//               {templateFile && (
//                 <span style={{ marginLeft: "10px" }}>{templateFile.name}</span>
//               )}
//             </label>
//           </Grid>
//           <Grid item xs={12}>
//             <FormControl fullWidth>
//               <InputLabel id="icon-select-label">Choose Icon</InputLabel>
//               <Select
//                 labelId="icon-select-label"
//                 value={selectedIcon}
//                 onChange={handleIconChange}
//                 label="Choose Icon"
//               >
//                 {icons.map((icon) => (
//                   <MenuItem key={icon.name} value={icon.name}>
//                     {icon.name}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//             {SelectedIconComponent && (
//               <div style={{ marginTop: "20px", textAlign: "center" }}>
//                 <SelectedIconComponent style={{ fontSize: 40 }} />
//               </div>
//             )}
//           </Grid>
//           <Grid item xs={12}>
//             <Typography variant="subtitle1">Template State</Typography>
//             <Switch
//               checked={templateState}
//               onChange={handleStateChange}
//               color="primary"
//             />
//           </Grid>
//           <Grid item xs={6}>
//             <Button type="submit" variant="contained" color="primary" fullWidth>
//               Save Template
//             </Button>
//           </Grid>
//         </Grid>
//       </form>
//     </Paper>
//   );
// };

// export default AddTemplate;
// import React from 'react';
// import { useFormik } from 'formik';
// import * as Yup from 'yup';
// import axios from 'axios';
// import {
//   TextField,
//   Button,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Switch,
//   Typography,
//   Grid,
//   Paper
// } from '@mui/material';

const AddTemplate = ({ existingTemplate, onSubmit }) => {
  const { t } = useTranslation(["forms"]);
  const formik = useFormik({
    initialValues: {
      templateName: existingTemplate ? existingTemplate.Name : "",
      templateFile: null, // Will remain null in edit mode unless a new file is selected
      selectedIcon: existingTemplate ? existingTemplate.IconName : "",
      templateState: existingTemplate ? existingTemplate.State : false,
    },
    validationSchema: Yup.object({
      templateName: Yup.string().required(t("template-name-required")),
      templateFile: Yup.mixed()
        .test("fileRequired", t("template-file-required"), (value) => {
          if (existingTemplate) return true; // Skip validation if in edit mode
          return value !== null;
        })
        .test(
          "fileType",
          t("unsupported-file-format"),
          (value) =>
            value &&
            [
              "application/pdf",
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            ].includes(value.type)
        ),
      selectedIcon: Yup.string().required(t("template-icon-required")),
    }),
    onSubmit: async (values, { resetForm }) => {
      const formData = new FormData();
      if (values.templateFile) {
        formData.append("FileName", values.templateFile);
      }
      formData.append("Name", values.templateName);
      formData.append("IconName", values.selectedIcon);
      formData.append("State", values.templateState);

      try {
        if (existingTemplate) {
          // Edit existing template
          const response = await axios.put(
            `${uri}templates/${existingTemplate.Id}`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );
          console.log("Template updated successfully", response.data);
        } else {
          // Add new template
          const response = await axios.post(
            `${uri}templates`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );
          console.log("Template added successfully", response.data);
        }
        // Reset form fields
        resetForm();
        // Call the onSubmit callback to refresh the parent component
        onSubmit();
      } catch (error) {
        console.error("Error saving template", error);
      }
    },
  });
  const SelectedIconComponent =
    icons.find((icon) => icon.name === formik.values.selectedIcon)?.component ||
    null;
  return (
    <Paper elevation={3} style={{ padding: "20px", marginTop: "20px" }}>
      <Typography variant="h5" component="h3">
        {existingTemplate ? t("edit-template") : t("add-new-template")}
      </Typography>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={3} style={{ marginTop: "20px" }}>
          <Grid item xs={12}>
            <TextField
              label={t("template-name")}
              fullWidth
              name="templateName"
              value={formik.values.templateName}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.templateName &&
                Boolean(formik.errors.templateName)
              }
              helperText={
                formik.touched.templateName && formik.errors.templateName
              }
            />
          </Grid>
          <Grid item xs={12}>
            <input
              type="file"
              name="templateFile"
              onChange={(event) =>
                formik.setFieldValue(
                  "templateFile",
                  event.currentTarget.files[0]
                )
              }
              accept=".docx,.pdf"
              style={{ display: "none" }}
              id="templateFile"
            />
            <label htmlFor="templateFile">
              <Button variant="contained" component="span">
                {existingTemplate
                  ? t("change-template-file")
                  : t("upload-template-file")}
              </Button>
              {formik.values.templateFile && (
                <span style={{ marginLeft: "10px" }}>
                  {formik.values.templateFile.name}
                </span>
              )}
            </label>
            {formik.touched.templateFile && formik.errors.templateFile && (
              <Typography color="error">
                {formik.errors.templateFile}
              </Typography>
            )}
          </Grid>
          <Grid item xs={6}>
            <FormControl
              fullWidth
              error={
                formik.touched.selectedIcon &&
                Boolean(formik.errors.selectedIcon)
              }
            >
              <InputLabel id="icon-select-label">{t("choose-icon")}</InputLabel>
              <Select
                labelId="icon-select-label"
                name="selectedIcon"
                value={formik.values.selectedIcon}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                label={t("choose-icon")}
              >
                {icons.map((icon) => (
                  <MenuItem key={icon.name} value={icon.name}>
                    {icon.name}
                  </MenuItem>
                ))}
              </Select>
              {formik.touched.selectedIcon && formik.errors.selectedIcon && (
                <Typography color="error">
                  {formik.errors.selectedIcon}
                </Typography>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            {SelectedIconComponent && (
              <div style={{ marginTop: "20px", textAlign: "center" }}>
                <SelectedIconComponent style={{ fontSize: 40 }} />
              </div>
            )}
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle1">{t("template-state")}</Typography>
            <Switch
              name="templateState" 
              checked={formik.values.templateState}
              onChange={formik.handleChange}
              color="primary"
            />
          </Grid>
          <Grid item xs={6}>
            <Button type="submit" variant="contained" color="primary" fullWidth>
              {existingTemplate ? t("update-template") : t("save-template")}
            </Button>
          </Grid>
          <Grid item xs={6}>
          {existingTemplate &&
            <Button onClick={()=>{
              onSubmit();
            }}  variant="contained" color="primary" fullWidth>
              {t("cancel")}
            </Button> 
            }
          </Grid>
        </Grid>
      </form>
    </Paper>
  );
};

export default AddTemplate;

// const AddTemplate = () => {
//   const formik = useFormik({
//     initialValues: {
//       templateName: "",
//       templateFile: null,
//       selectedIcon: "",
//       templateState: false,
//     },
//     validationSchema: Yup.object({
//       templateName: Yup.string().required("Template name is required"),
//       templateFile: Yup.mixed()
//         .required("Template file is required")
//         .test(
//           "fileType",
//           "Unsupported file format",
//           (value) =>
//             value &&
//             [
//               "application/pdf",
//               "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
//             ].includes(value.type)
//         ),
//       selectedIcon: Yup.string().required("Template icon is required"),
//     }),
//     onSubmit: async (values, { resetForm }) => {
//       const formData = new FormData();
//       formData.append("FileName", values.templateFile);
//       formData.append("Name", values.templateName);
//       formData.append("IconName", values.selectedIcon);
//       formData.append("State", values.templateState);

//       try {
//         const response = await axios.post(
//           "http://localhost:8189/api/templates",
//           formData,
//           {
//             headers: {
//               "Content-Type": "multipart/form-data",
//             },
//           }
//         );
//         console.log("Template added successfully", response.data);
//         // Reset form fields
//         resetForm();
//       } catch (error) {
//         console.error("Error adding template", error);
//       }
//     },
//   });
//   const SelectedIconComponent =
//     icons.find((icon) => icon.name === formik.touched)?.component || null;

//   return (
//     <Paper elevation={3} style={{ padding: "20px", marginTop: "20px" }}>
//       <Typography variant="h5" component="h3">
//         Add New Template
//       </Typography>
//       <form onSubmit={formik.handleSubmit}>
//         <Grid container spacing={3} style={{ marginTop: "20px" }}>
//           <Grid item xs={12}>
//             <TextField
//               label="Template Name"
//               fullWidth 
//               name="templateName"
//               value={formik.values.templateName}
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               error={
//                 formik.touched.templateName &&
//                 Boolean(formik.errors.templateName)
//               }
//               helperText={
//                 formik.touched.templateName && formik.errors.templateName
//               }
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <input
//               type="file"
//               name="templateFile"
//               onChange={(event) =>
//                 formik.setFieldValue(
//                   "templateFile",
//                   event.currentTarget.files[0]
//                 )
//               }
//               accept=".docx,.pdf"
//               style={{ display: "none" }}
//               id="templateFile"
//             />
//             <label htmlFor="templateFile">
//               <Button variant="contained" component="span">
//                 Upload Template File
//               </Button>
//               {formik.values.templateFile && (
//                 <span style={{ marginLeft: "10px" }}>
//                   {formik.values.templateFile.name}
//                 </span>
//               )}
//             </label>
//             {formik.touched.templateFile && formik.errors.templateFile && (
//               <Typography color="error">
//                 {formik.errors.templateFile}
//               </Typography>
//             )}
//           </Grid>
//           <Grid item xs={12}>
//             <FormControl
//               fullWidth
//               error={
//                 formik.touched.selectedIcon &&
//                 Boolean(formik.errors.selectedIcon)
//               }
//             >
//               <InputLabel id="icon-select-label">Choose Icon</InputLabel>
//               <Select
//                 labelId="icon-select-label"
//                 name="selectedIcon"
//                 value={formik.values.selectedIcon}
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//                 label="Choose Icon"
//               >
//                 {icons.map((icon) => (
//                   <MenuItem key={icon.name} value={icon.name}>
//                     {icon.name}
//                   </MenuItem>
//                 ))}
//               </Select>
//               {formik.touched.selectedIcon && formik.errors.selectedIcon && (
//                 <Typography color="error">
//                   {formik.errors.selectedIcon}
//                 </Typography>
//               )}
//             </FormControl>
//             {SelectedIconComponent && (
//               <div style={{ marginTop: "20px", textAlign: "center" }}>
//                 <SelectedIconComponent style={{ fontSize: 40 }} />
//               </div>
//             )}
//           </Grid>
//           <Grid item xs={12}>
//             <Typography variant="subtitle1">Template State</Typography>
//             <Switch
//               name="templateState"
//               checked={formik.values.templateState}
//               onChange={formik.handleChange}
//               color="primary"
//             />
//           </Grid>
//           <Grid item xs={6}>
//             <Button type="submit" variant="contained" color="primary" fullWidth>
//               Save Template
//             </Button>
//           </Grid>
//         </Grid>
//       </form>
//     </Paper>
//   );
// };

// export default AddTemplate;
